export const PRESENTATION_S3_DIRECTORY = 'presentations';

export const PRESENTATION_FILE_FORMAT = ['pptx'];

export const EXPORT_TYPE = {
  PPTX: 'PPTX',
  VIDEO: 'VIDEO',
  JOIN_AUDIO: 'JOIN_AUDIO',
  SEPARATE_AUDIO: 'SEPARATE_AUDIO',
  SEPARATE_AUDIO_PARTIAL: 'SEPARATE_AUDIO_PARTIAL',
  SRT: 'SRT',
  // The merged audio of a dubbing project whose source is a subtitle file. Kept
  // apart from JOIN_AUDIO because the backend builds it from the whole-project
  // synthesis rather than from per-block audio.
  AUDIO_SRT: 'AUDIO_SRT',
};

// Video rendering engine, chosen by the user via the "Animation" dropdown when
// exporting a video. v1 composites static slide images (skips animations);
// v2 renders the real PPTX and keeps animations.
export const VIDEO_EXPORT_ENGINE = {
  V1: 'v1',
  V2: 'v2',
};

export const NARRATION_MODELS = {
  FLASH: 'vbee-slide-flash',
  PRO: 'vbee-slide-pro',
};

export const PPTX_REGEX = {
  SLIDE_FILE: /^ppt\/slides\/slide\d+\.xml$/,
  SLIDE_PREFIX: /^ppt\/slides\//,
  SLIDE_NUMBER: /\d+/,
  NOTE_FILE: /^ppt\/notesSlides\/notesSlide\d+\.xml$/,
  NOTE_REL_TARGET: /Target="\.\.\/notesSlides\/(notesSlide\d+\.xml)"/,
  NOTE_TEXT_TAG: /<a:t>([^<]*)<\/a:t>/g,
  NOTE_TEXT_STRIP: /<a:t>|<\/a:t>/g,
  // Auto fields (slide number, date, footer) live in <a:fld>...</a:fld> and
  // must be stripped before counting/measuring real speaker-note text.
  NOTE_FIELD: /<a:fld\b[^>]*>[\s\S]*?<\/a:fld>/g,
};
